import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ variant = 'default' }) => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'de', name: t('language.de'), flag: '🇩🇪' },
    { code: 'en', name: t('language.en'), flag: '🇬🇧' },
    { code: 'fr', name: t('language.fr'), flag: '🇫🇷' }
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  if (variant === 'compact') {
    return (
      <Select value={i18n.language} onValueChange={handleLanguageChange}>
        <SelectTrigger className="w-auto h-9 px-2 rounded-sm border-slate-200 bg-white hover:bg-slate-50">
          <div className="flex items-center gap-1.5">
            <Globe className="w-4 h-4 text-slate-500" />
            <span className="text-sm">{currentLang.flag}</span>
          </div>
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <div className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-40 rounded-sm border-slate-200 bg-white hover:bg-slate-50" data-testid="language-selector">
        <div className="flex items-center gap-2">
          <Globe className="w-4 h-4 text-slate-500" />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <div className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
